import React from 'react';
import WebSite from './webSitePolicies';

function Policies() {
  return (
    <div>
      <WebSite />
    </div>
  );
}

export default Policies;